// Modelo Compañia para administrador.
export default class AnexoSaludTrabajo {
    fecha={}
    tipoExamen=[
        {valor:false, descripcion:"", tipo:1 ,label:"PREOCUPACIONAL"},
        {valor:false, descripcion:"", tipo:1 ,label:"INICIAL"},
        {valor:false, descripcion:"", tipo:1 ,label:"PERIÓDICO"},
        {valor:false, descripcion:"", tipo:1 ,label:"REUBICACIÓN"},
        {valor:false, descripcion:"", tipo:1 ,label:"ESPECIAL"},
        {valor:false, descripcion:"", tipo:1 ,label:"RETIRO"},
        {valor:false, descripcion:"", tipo:1 ,label:"REINSERCIÓN"}
    ]
    medicamentos=[
        {valor:false, descripcion:"", tipo:1 ,label:"¿Está usted consumiendo algún medicamento al momento?", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"¿Regularmente se automedica?", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"¿Consume medicamentos para dormir?", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"¿Consume regularmente antidepresivos?", data:["SI","NO"]},
        {tipo:0 ,label:"MSP"},
        {valor:"", descripcion:"", tipo:3 ,label:"Medicamento 1"},
        {valor:"", descripcion:"", tipo:3 ,label:"Medicamento 2"},
        {valor:"", descripcion:"", tipo:3 ,label:"Medicamento 3"},
        {valor:"", descripcion:"", tipo:3 ,label:"Medicamento 4"},
        {valor:"", descripcion:"", tipo:3 ,label:"Medicamento 5"},

    ]
    adicciones=[
        //tabaco
        {tipo:0 ,label:"TABACO"},
        {valor:false, descripcion:"", tipo:2 ,label:"¿Fuma?", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"¿Fumaba?", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:5 ,label:"Unidades/día/mes", },
        {valor:false, descripcion:"", tipo:3 ,label:"Tiempo de consumo (años)", data:["0","MENOS DE 1","1-4","5-9","10-14","15-19","20-24","25-29", "30-34","35-39","MAS DE 40"]},
        {valor:false, descripcion:"", tipo:2 ,label:"¿Es fumador pasivo?", data:["SI","NO"]},
        //drogas
        {tipo:0 ,label:"DROGAS"},
        {valor:false, descripcion:"", tipo:2 ,label:"¿Se siente atraído a oler thinner/gasolina?", data:["SI","NO"]},
        {valor:false, descripcion:"", descripcion2:"", tipo:3 ,label:"¿Consume usted drogas?", data:["NO","MARIHUANA","COCAINA","EXTASIS","DROGA H","ANFETAMINA","OTRAS"]},
        //alcohol
        {tipo:0 ,label:"ALCOHOL"},
        {valor:false, descripcion:"", tipo:2 ,label:"¿Consume alcohol?",data:["SI","NO"] },
        {valor:false, descripcion:"", tipo:2 ,label:"¿Consume alcohol sólo?" ,data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:3 ,label:"¿Frecuencia semanal?" ,data:["1-5 VASOS DE VINO/CERVEZA","MAS DE 5 VASOS DE VINO/CERVEZA","1-5 COPAS DE LICOR","MAS DE 5 COPAS DE LICOR","HASTA EMBRIAGARSE UNA VEZ POR SEMANA","HASTA EMBRIAGARSE MAS DE UNA VEZ POR SEMANA"]},
        //otras
        {tipo:0 ,label:"OTRAS"},
        {valor:false, descripcion:"", tipo:2 ,label:"¿Posee síntomas de ciberdependencia?", tooltip:true},

        {tipo:0 ,label:"MSP"},
        {valor:false, descripcion:"", tipo:1 ,label:"HÁBITOS TÓXICOS - TABACO - TIEMPO DE ABSTINENCIA"},

        {valor:false, descripcion:"", tipo:1 ,label:"HÁBITOS TÓXICOS - ALCOHOL - TIEMPO DE CONSUMO"},
        {valor:false, descripcion:"", tipo:1 ,label:"HÁBITOS TÓXICOS - ALCOHOL - EX CONSUMIDOR"},
        {valor:false, descripcion:"", tipo:1 ,label:"HÁBITOS TÓXICOS - ALCOHOL - TIEMPO DE ABSTINENCIA"},

        {valor:false, descripcion:"", tipo:1 ,label:"HÁBITOS TÓXICOS - DROGAS - TIEMPO DE CONSUMO"},
        {valor:false, descripcion:"", tipo:1 ,label:"HÁBITOS TÓXICOS - DROGAS - CANTIDAD"},
        {valor:false, descripcion:"", tipo:1 ,label:"HÁBITOS TÓXICOS - DROGAS - EX CONSUMIDOR"},
        {valor:false, descripcion:"", tipo:1 ,label:"HÁBITOS TÓXICOS - DROGAS - TIEMPO DE ABSTINENCIA"}

    ]
    habitos=[
        {valor:false, descripcion:"", tipo:2 ,label:"¿Practica regularmente deporte?", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:3 ,label:"Frecuencia semanal", data:["NO PRACTICA DEPORTE","UNA VEZ A LA SEMANA","2 - 3 VECES A LA SEMANA","MAS DE 3 VECES A LA SEMANA"]},
        {valor:false, descripcion:"", tipo:1 ,label:"¿Cuál deporte?" },
        {valor:false, descripcion:"", tipo:2 ,label:"¿Ha tenido alteraciones a la salud a causa del deporte?", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:4 ,label:"Especifique" }
    ]
    informacionOcupacional=[
        {valor:false, descripcion:"", tipo:1 ,label:"Cargo actual u ocupación a desempeñar" },
        {valor:false, descripcion:"", tipo:3 ,label:"Seleccione", data:["White Collar (CUELLO BLANCO)","Blue Collar (CUELLO AZUL)"]},
        {valor:false, descripcion:"", tipo:3 ,label:"Tipo de turno", data:["DIURNO","NOCTURNO","ROTATIVO"]},
        {valor:false, descripcion:"", tipo:3 ,label:"Postura de trabajo predominante", data:["PARADO","SENTADO","DEAMBULANDO"]},
        {tipo:0 ,label:"Tiempo en cargo"},
        {valor:false, descripcion:"", tipo:3 ,label:"Años", data:["0","1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49"]},
        {valor:false, descripcion:"", tipo:3 ,label:"Meses", data:["0","1","2","3","4","5","6","7","8","9","10","11"]},
        {valor:false, descripcion:"", tipo:3 ,label:"Duración de jornada", data:["1h","2h","3h","4h","5h","6h","7h","8h","9h","10h","11h","12h","13h","14h","15h","16h","17h","18h","19h","20h","21h","22h","23h","24h"]},
        {tipo:0 ,label:"Rotación de turnos"},
        {valor:false, descripcion:"", tipo:3 ,label:"días de trabajo X", data:["1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","60"]},
        {valor:false, descripcion:"", tipo:3 ,label:"días de descanso", data:["1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","60"]},
        {valor:false, descripcion:"", descripcion2:"",tipo:3 ,label:"Tipo de contrato", data:["TIEMPO INDEFINIDO","TIEMPO FIJO","EVENTUAL","OCASIONAL","JORNADA PARCIAL","DE TEMPORADA","OTRO"]},
        
    ]
    informacionOcupacionalProcesosPeligrosos=[];
    informacionOcupacionalProcesosPeligrososListas=[];
    antecedentesOcupacionales=[
        {valor:false, descripcion:"", tipo:1 ,label:"Empresa" },
        {valor:false, descripcion:"", tipo:1 ,label:"Cargo u ocupación desempeñada" },
        {valor:false, descripcion:"", tipo:3 ,label:"Turno", data:["DIURNO","NOCTURNO","ROTATIVO"]},
        {valor:false, descripcion:"", tipo:3 ,label:"Postura de trabajo predominante", data:["PARADO","SENTADO","DEAMBULANDO"]},
        {tipo:0 ,label:"Tiempo en cargo"},
        {valor:false, descripcion:"", tipo:3 ,label:"Años", data:["0","1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49"]},
        {valor:false, descripcion:"", tipo:3 ,label:"Meses", data:["0","1","2","3","4","5","6","7","8","9","10","11"]},
        {valor:false, descripcion:"", tipo:3 ,label:"Duración de jornada", data:["1h","2h","3h","4h","5h","6h","7h","8h","9h","10h","11h","12h","13h","14h","15h","16h","17h","18h","19h","20h","21h","22h","23h","24h"]},
        {tipo:0 ,label:"Turnos de"},
        {valor:false, descripcion:"", tipo:3 ,label:"días de trabajo X", data:["1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","60"]},
        {valor:false, descripcion:"", tipo:3 ,label:"dias de descanso", data:["1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","60"]},
        {valor:false, descripcion:"", descripcion2:"", tipo:3 ,label:"Tipo de contrato", data:["TIEMPO INDEFINIDO","TIEMPO FIJO","EVENTUAL","OCASIONAL","JORNADA PARCIAL","DE TEMPORADA","OTRO"]},
        
    ]
    antecedentesOcupacionalesProcesosPeligrosos=[]
    accidentesTrabajo=[
        {valor:false, descripcion:"", tipo:5 ,label:"Fecha aproximada"},
        {valor:false, descripcion:"", tipo:1 ,label:"Empresa"},
        {valor:false, descripcion:"", tipo:3 ,label:"Tipo incapacidad", data:["NINGUNA","INCAPACIDAD TEMPORAL","INCAPACIDAD PERMANENTE PARCIAL","INCAPACIDAD PERMANENTE TOTAL","INCAPACIDAD PERMANENTE ABSOLUTA","MUERTE"]},
        {valor:false, descripcion:"", tipo:1 ,label:"Días incapacidad"},
        {valor:false, descripcion:"", tipo:4 ,label:"Descripción del accidente" },
        {valor:false, descripcion:"", tipo:4 ,label:"Alteración a la salud" },
        {valor:false, descripcion:"", tipo:0 ,label:"MSP"},
        {valor:false, descripcion:"", tipo:6 ,label:"INCIDENTES", fecha:"", menu:""},
        {valor:false, descripcion:"", tipo:6 ,label:"ACCIDENTES", fecha:"", menu:""},
        {valor:false, descripcion:"", tipo:7 ,label:"FUE CALIFICADO POR EL INSTITUTO DE SEGURIDAD SOCIAL CORRESPONDIENTE:", fecha:"", menu:""},

    ]
    enfermedadProfesional=[
        {valor:false, descripcion:"", tipo:5 ,label:"Fecha aproximada"},
        {valor:false, descripcion:"", tipo:3 ,label:"Tipo incapacidad", data:["NINGUNA","INCAPACIDAD TEMPORAL","INCAPACIDAD PERMANENTE PARCIAL","INCAPACIDAD PERMANENTE TOTAL","INCAPACIDAD PERMANENTE ABSOLUTA","MUERTE"]},
        {valor:false, descripcion:"", tipo:3 ,label:"Reubicación", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:0 ,label:"MSP"},
        {valor:false, descripcion:"", tipo:6 ,label:"ENFERMEDADES PROFESIONALES-FECHA", fecha:"", menu:""},
        {valor:false, descripcion:"", tipo:7 ,label:"FUE CALIFICADO POR EL INSTITUTO DE SEGURIDAD SOCIAL CORRESPONDIENTE:", fecha:"", menu:""},
    ]
    procesosPositivos=[
        {valor:false, descripcion:"", tipo:2 ,label:"¿En su tarea existe relación entre concepción y ejecución?", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"¿Su trabajo le permite un desarrollo físico y mental de igual a igual?\t", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"¿Existe en su trabajo compañerismo?", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"¿Existe en su trabajo solidaridad?", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"¿Tiene variaciones adecuadas de su actividad?", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"¿Son sus tareas creativas?", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"¿Su trabajo es valorado por sus compañeros?", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"¿Su trabajo es valorado por sus jefes?", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"¿Tiene capacitación permanente?", data:["SI","NO"]},
        {tipo:0 ,label:"¿En su centro de trabajo dispone de?"},
        {valor:false, descripcion:"", tipo:2 ,label:"Gimnasios", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"Talleres de arte", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"Clubes diversos (teatro, ajedrez, etc.)", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"Programas de apoyo comunitario", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"Salario justo", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"Programas recreativos", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"Programas de turismo", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"Comedor/Cafetería", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"Servicios de salud", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"Guardería", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"Centro educativo", data:["SI","NO"]}

    ]
    manifestacionesSaludables=[
        {tipo:0 ,label:"En su trabajo siente:"},
        {valor:false, descripcion:"", tipo:2 ,label:"Satisfacción en la realización de las actividades", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"Que se ha desarrollado su creatividad e iniciativa", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"Que se ha desarrollado sus habilidades y destrezas", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"Que tiene nuevos conocimientos", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"Que ha mejorado su capacidad física y mental", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"Alegría por el trabajo", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"Que es solidario y generoso con los demás", data:["SI","NO"]}
    ]

    actividadesRelevantes=[
        {tipo:0 ,label:"ACTIVIDADES RELEVANTES DE SU TRABAJO\n"},
        {valor:false, descripcion:"", tipo:4 ,label:""}
    ]
    actividadesExtraLaborales=[
        {tipo:0 ,label:"ACTIVIDADES EXTRA LABORALES"},
        {valor:false, descripcion:"", tipo:2 ,label:"¿Realiza actividades extra laborales?", data:["SI","NO"]},
        {tipo:0 ,label:"Tests"},
        {puntaje:"", fecha:"", interpretacion:"", tipo:8 ,label:"IATL (Índice de Actividad en el Tiempo Libre)"},
        {puntaje:"", fecha:"", interpretacion:"", tipo:8 ,label:"ICTD (Índice de Carga de Trabajo Doméstico)"}
    ]
    nRetiroEvaluacion=[
        {tipo:0 ,label:"RETIRO (evaluación)"},
        {valor:true, tipo:2 ,label:"Habilitar", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"SE REALIZA LA EVALUACIÓN", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:2 ,label:"LA CONDICIÓN DE SALUD ESTÁ RELACIONADA CON EL TRABAJO", data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:4 ,label:"Observación:" }
    ]
}
var today = new Date();
var dd = today.getDate();
var mm = today.getMonth() + 1; //January is 0!

var yyyy = today.getFullYear();
if (dd < 10) {
    dd = '0' + dd;
}
if (mm < 10) {
    mm = '0' + mm;
}
var today = dd + '/' + mm + '/' + yyyy;



// WEBPACK FOOTER //
// ./src/model/AnexoSaludTrabajo.js